import { Observable } from "rxjs";

export interface AlternativeContentActionConfigBase {
  label: string;
  icon?: string;
  actionType?: "button" | "dropdown"; // "button" by default
  actionCallback?: () => void | Promise<void>;
  bgBtn?: "primary" | "secondary" | "ghost" | string;
  dataTour?: string;
  canExecute?: () => boolean | Observable<boolean>;
  disableCallback?: () => boolean | Observable<boolean>;
}

// A dropdown child: no actionType or children (always a simple action)
export interface AlternativeContentActionChildConfig {
  label: string;
  icon?: string;
  providerValue?: string;
  showProviderLogo?: boolean;
  actionCallback: () => void | Promise<void>; // required
  bgBtn?: "primary" | "secondary" | "ghost" | string;
  dataTour?: string;
  canExecute?: () => boolean | Observable<boolean>;
  disableCallback?: () => boolean | Observable<boolean>;
}

// Main action: can be button or dropdown (single level only)
export interface AlternativeContentActionConfig
  extends AlternativeContentActionConfigBase {
  children?: AlternativeContentActionChildConfig[]; // Only when actionType === "dropdown"
}

export interface AlternativeContentConfig {
  imageSrc?: string;
  imageAlt?: string;
  iTablerIcon?: string;
  title?: string;
  description: string;
  actions?: AlternativeContentActionConfig[];
}
